type Props = {
  title: {
    text: string
    styles?: {
      color?: string
    }
  }
}

export const Title = ({ title }: Props) => {
  const { text, styles } = title || {}
  return (
    <h2
      className="font-semibold text-xl md:text-2xl leading-none"
      style={{
        color: styles?.color,
      }}
    >
      {text}
    </h2>
  )
}
